// Imports
import './assets/scss/style.scss'

import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'

import Auth from './packages/Auth'

import App from './App.vue'

// import Ads from 'vue-google-adsense';
// Vue.use(require('vue-script2'));
// Vue.use(Ads.AutoAdsense, {
//   adClient: 'ca-pub-8624981509801185',
//   isNewAdsCode: false,
// });

import datePicker from 'vue-bootstrap-datetimepicker'

import store from './store'

import router from './router'

import Quill from 'quill'
import VueQuillEditor from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/imageDrop', ImageDrop)
Vue.use(VueQuillEditor)
Vue.use(datePicker)

// Atributos de cada input
import AttributesEs from './lang/attributesEs'
import AttributesEn from './lang/attributesEn'
import AttributesPt from './lang/attributesPt'
import AttributesIt from './lang/attributesIt'
import AttributesFr from './lang/attributesFr'
import AttributesDe from './lang/attributesDe'

import VueI18n from 'vue-i18n'

import VeeValidate, { Validator } from 'vee-validate'

// Validaciones en español
import Es from 'vee-validate/dist/locale/es'
import En from 'vee-validate/dist/locale/en'
import Pt from 'vee-validate/dist/locale/pt_PT'
import It from 'vee-validate/dist/locale/it'
import Fr from 'vee-validate/dist/locale/fr'
import De from 'vee-validate/dist/locale/de'

import Multiselect from 'vue-multiselect'

require('./config/constants')

require('./config/toastr')

require('./config/axios')

// Uses
Vue.use(BootstrapVue)

Vue.use(Auth)

Vue.use(VeeValidate, {
	classes: true,
	classNames: {
		valid: 'is-valid',
		invalid: 'is-invalid',
	},
	inject: true,
	dictionary: {
		es: {
			attributes: AttributesEs,
		},
		en: {
			attributes: AttributesEn,
		},
		pt: {
			attributes: AttributesPt,
		},
		it: {
			attributes: AttributesIt,
		},
		de: {
			attributes: AttributesDe,
		},
		fr: {
			attributes: AttributesFr,
		},
	},
	fieldsBagName: 'veeFields',
})

Vue.use(VueI18n)

import LangEn from './lang/en'
import LangEs from './lang/es'
import LangPt from './lang/pt'
import LangIt from './lang/it'
import LangFr from './lang/fr'
import LangDe from './lang/de'

const i18n = new VueI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages: {
		es: LangEs,
		en: LangEn,
		pt: LangPt,
		de: LangDe,
		fr: LangFr,
		it: LangIt,
	},
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	const lang = to.params.lang
	const currentLang = localStorage.getItem('lang')

	if (!['es', 'en', 'pt', 'it', 'de', 'fr'].includes(lang)) {
		if (!currentLang) {
			return next('en')
		} else {
			return next(currentLang)
		}
	}

	if (!currentLang) {
		localStorage.setItem('lang', lang)
	}

	if (i18n.locale !== lang) {
		i18n.locale = lang
	}

	if (lang === 'pt') {
		Validator.localize(lang, Pt)
	} else if (lang === 'en') {
		Validator.localize(lang, En)
	} else if (lang === 'it') {
		Validator.localize(lang, It)
	} else if (lang === 'fr') {
		Validator.localize(lang, Fr)
	} else if (lang === 'de') {
		Validator.localize(lang, De)
	} else {
		Validator.localize(lang, Es)
	}

	const isPublic = to.matched.some((url) => {
		return url.meta.isPublic
	})

	const isAuthenticated = Vue.auth.isAuthenticated()
	if (!isPublic && !isAuthenticated) {
		next({ name: 'Login', params: { lang } })
	} else if (!isPublic && isAuthenticated) {
		next()
	} else {
		next()
	}
})

// Componentes globales
import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)

Vue.component('multiselect', Multiselect)

Vue.mixin({
	filters: {
		toLowerCase(str) {
			return str.toLowerCase()
		},
		toCapitalize(str) {
			return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
		},
		money(value) {
			return Number(value).toFixed(2)
		},
		moneyFormat(number) {
			return Number(number).toLocaleString('en')
		},
		completePosition(position) {
			return window.positions
				.filter((p) => {
					return p.value === position
				})
				.reduce((p) => {
					return p
				}).text
		},
		completeUserType(type) {
			if (type === 'ADMIN') {
				return 'ADMINISTRATOR'
			} else if (type === 'FULL') {
				return 'FULL ADMINISTRATOR'
			} else if (type === 'SUPER') {
				return 'SUPER ADMINISTRATOR'
			}
			return type
		},
	},
	methods: {
		setUserAfterLogin(data, lang, console) {
			const tokenAndType = `Bearer ${data.token}`
			this.$auth.setToken(tokenAndType, data.expires_at)
			this.$axios.defaults.headers.common['Authorization'] = tokenAndType
			this.$store.dispatch('SET_AUTHENTICATED', true)
			const user = {
				id: data.user.id,
				nick: data.user.nick,
				username: data.user.username,
				email: data.user.email,
				console: data.user.console,
				slug: data.user.slug,
				position: data.user.position,
				isAdmin: data.user.is_admin ? true : false,
				type: data.user.type,
				money: data.user.money,
			}
			this.$store.dispatch('SET_USER', user)
			localStorage.setItem('user', JSON.stringify(user))
			this.$store.dispatch('SET_MY_TUTORIALS', data.user.tutorials)
			this.$router.push({ name: 'Dashboard', params: { lang, console } })
			this.changeLanguage(lang)
		},
		productTypes() {
			return [
				{ value: 'AV', text: 'Avatar' },
				{ value: 'BT', text: this.$t('bgTournaments') },
				{ value: 'BD', text: this.$t('bgDivisions') },
				{ value: 'BE', text: this.$t('bgTeams') },
				{ value: 'BU', text: this.$t('bgPlayers') },
				{ value: 'CA', text: this.$tc('card', 2) },
			]
		},
		closeAllDD() {
			document.body.click()
		},
		changeTitleBar(title) {
			document.title = `${title} - ITFA`
		},
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.errors.has(ref)
			}
			return null
		},
		changeLanguage(lang) {
			const localeName = lang === 'pt' ? 'pt_PT' : lang
			import(`vee-validate/dist/locale/${localeName}`).then(() => {
				this.$validator.localize(lang)
			})
			localStorage.setItem('lang', lang)
			this.$store.dispatch('SET_LANG', lang)
			this.$i18n.locale = lang
			let routeParams = this.$route.params
			if (routeParams.hasOwnProperty('lang')) {
				routeParams.lang = lang
			}
			this.$router.push({ name: this.$route.name, params: routeParams })
		},
		updateLang() {
			const lang = this.$route.params.lang
			const currentLang = localStorage.getItem('lang')
			if (!currentLang) {
				if (!lang) {
					localStorage.setItem('lang', 'en')
				} else {
					localStorage.setItem('lang', lang)
				}
			}
			if (!lang) {
				this.$store.dispatch('SET_LANG', 'en')
			} else {
				this.$store.dispatch('SET_LANG', lang)
			}
		},
		showValidationsErrors(errors) {
			errors.forEach((error) => {
				this.$toastr.info(error.msg, 'Ups...')
			})
		},
		capitalize(str) {
			return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
		},
	},
})

new Vue({
	store,
	router,
	i18n,
	render: (h) => h(App),
}).$mount('#app')
